/** @format */
export const initYaml = `  - record: job_instance_mode:apiserver_request_total:avg_rate5m  # 新指标名称,必填。须符合Prometheus指标名称规范。
    expr: avg by (job, instance, mode) (rate(apiserver_request_total[5m]))  # 规则，必填
    labels:  # 指标的标签，选填
      team: operations
  - record: job_instance_mode:apiserver_request_total:avg_rate5m
    expr: avg by (job, instance, mode) (rate(apiserver_request_total[5m]))
    labels:
      team: operations`

export interface RecordFormValue {
  Name: string
  Records: string
}
export const initRecordFormValues: RecordFormValue = {
  Name: '',
  Records: initYaml
}
